import { Component } from "react";
import Loader from "../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../../../utils/withRouter";
import { connect } from "react-redux";
import { fill_action } from '../../../../actions/fillCombo_action';
import { cityActionId, stallTypeActionId, stallListActionId, countryActionId, exhibitionActionId, toastError, toastSuccess } from "../../../../utils/constants";
import { emailValidator } from "../../../../utils/Validator";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Modal from "react-modal";
import moment from "moment";
import Pagination from "../../../../utils/pagination";
import AdminDrawer from "../../../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../../../common_components/header_with_logo";
import { useNavigate } from "react-router-dom";
import ExhibitorDrawer from "../../../../common_components/exhibitor_module_drawer";
import ExhibitorHeader from "../../../../common_components/exhibitor_module_header";
import { data } from "jquery";
import { getgstMasterList_action, deleteGSTMaster_action } from "../../../../actions/admin_module_action/master_action/gst_master_action";
import Footer from "../../../../common_components/Footer";


class GSTList extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            isOpen: false,
            currentPage: 1,
            GSTList: [],
            deleteID: '',
            GSTno: '',
            PANNo: '',
        }

        this.record = this.record.bind(this)
        this.clearSearch = this.clearSearch.bind(this)
        this.deleteGSTMaster = this.deleteGSTMaster.bind(this)
        this.handleAdd = this.handleAdd.bind(this)
        this.handleUpdate = this.handleUpdate.bind(this)
        this.onDelete = this.onDelete.bind(this)
        this.updateItem = this.updateItem.bind(this)
        this.getGSTMasterList = this.getGSTMasterList.bind(this)
    }

    componentDidMount() {

        this.getGSTMasterList()
    }

    record(list) {
        return (
            <table class="table sticky-table text-nowrap table-bordered border-bottom border-1 mb-0">
        <thead class="table-light">
                    <tr>
                        <th style={{ width: '50px' }}>SR no.</th>
                        <th className="text-center" >GSTIN</th>
                        <th className="text-center" >PAN No </th>
                        <th style={{ width: '50px' }}></th>
                        <th style={{ width: '50px' }}></th>

                    </tr>
                </thead>
                <tbody>
                    {
                        list.length > 0 ? <>{
                            list.map((data, i) => (
                                <tr key={Math.random()}>
                                    {/* <td className="text-center">{data.RoleID}</td> */}
                                    {/* <td className="text-center">{moment(data.ExhibitionDateFrom).format('L')}</td>
                                    <td className="text-center">{moment(data.ExhibitionDateTo).format('L')}</td>
                                <td className="text-center">{this.state.countryList.map(id => (parseInt(id.Code) == data.CountryID ? id.Description : null))}</td> */}
                                    <td className="text-center">{i + 1}</td>
                                    <td className="text-center">{data.GSTNo}</td>
                                    <td className="text-center">{data.PANNo}</td>
                                    <td className="text-center">
                                        <button
                                            type="button"
                                            className="btn btn-aqua"
                                            onClick={(e) => this.handleUpdate(data.GstPanMasterID)}
                                        >
                                            Update
                                        </button>
                                    </td>
                                    <td className="text-center">
                                        <button
                                            type="button"
                                            className="btn btn-outline-danger btn-sm"
                                            onClick={(e) => this.onDelete(data.GstPanMasterID)}
                                        >
                                            Delete
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </> :
                            <tr><td colSpan={13} style={{ textAlign: 'center' }}>Record not found</td></tr>
                    }
                </tbody>
            </table>)
    }

    getGSTMasterList() {
        this.setState({ isLoading: true })
        const { hallName, exhibitionID, GSTno, PANNo } = this.state
        this.props.getgstMasterList_action(exhibitionID, null, GSTno, PANNo)
            .then((data) => {
                if (data.error != 1) {
                    console.log(data.data[0])
                    this.setState({ GSTList: data.data[0] })
                    this.setState({ isLoading: false })
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    clearSearch() {
        const { GSTno, PANNo } = this.state
        this.setState({
            GSTno: '',
            PANNo: ''
        })
        setTimeout(() => {
            this.getGSTMasterList()
        }, 100);
    }

    handleAdd() {
        this.props.navigate('/gstAU', { state: { is_add: true, } })
    }

    handleUpdate(id) {
        this.props.navigate('/gstAU', { state: { is_update: true, GstPanMasterID: id } })
    }

    deleteGSTMaster(id) {
        this.setState({ isLoading: true })
        this.props.deleteGSTMaster_action(id)
            .then((data) => {
                if (data.error != 1) {
                    console.log(data.data)
                    this.setState({ isLoading: false })
                    toastSuccess("deleted successfully")
                    setTimeout(() => {
                        this.getGSTMasterList()
                    }, 200);
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
                this.setState({ isOpen: false })
            })
            .catch((err) => {
                console.log(err)
            })
    }

    onDelete(i) {
        const { } = this.state
        this.setState({ deleteID: i })
        this.setState({ isOpen: true, })
    }

    updateItem(item) {
        const { GSTList } = this.state
        this.setState({ currentPage: item });
        const recordsPerPage = 10;
        const indexOfLastRecord = item * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage
        const currentRecords = GSTList.slice(indexOfFirstRecord, indexOfLastRecord);
        const nPages = Math.ceil(GSTList.length / recordsPerPage)
        this.setState({ startIndex: recordsPerPage * (item - 1) });
    }

    render() {
        const { isOpen, isLoading, exhibitionID, currentPage, GSTList, GSTno, PANNo } = this.state
        const recordsPerPage = 10;
        const indexOfLastRecord = currentPage * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage
        const currentRecords = GSTList.slice(indexOfFirstRecord, indexOfLastRecord);
        const nPages = Math.ceil(GSTList.length / recordsPerPage)
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}

                <ToastContainer />
                <HeaderWithLogo />

                <>
                    <div className="app-content with-dr-container com-height">
                        <AdminDrawer />
                        <div className="row m-0">
                            <div className="breadcrumb-scroll-fixed">
                                <h6 className="mb-0 p-2 text-white">
                                    GST Master List</h6>
                            </div>
                        </div>
                        <div className="admin-top-space p-2">
                                {
                                    JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID != 1 &&
                                    <div className="row m-0">
                                        <div className="col-md-4">
                                            <label>GSTIN</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={GSTno}
                                                onChange={(e) => this.setState({ GSTno: e.target.value.toUpperCase(), })}
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <label>Pan no</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={PANNo}
                                                onChange={(e) => this.setState({ PANNo: e.target.value.toUpperCase(), })}
                                            />
                                        </div>
                                         <div className="col-md-4 mt-2">
                                            <label></label>
                                    {
                                        JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID != 1 &&
                                        <div
                                            className="mb-1"
                                            role="group"
                                            aria-label="Basic example"
                                            style={{ float: "right" }}
                                        >
                                            <button type="button" className="btn btn-aqua"
                                                onClick={e => this.getGSTMasterList()}
                                            >
                                                Search
                                            </button>
                                            <button type="button" className="btn btn-aqua mx-2"
                                                onClick={e => this.handleAdd()}
                                            >
                                                Add
                                            </button>
                                            <button type="button" className="btn btn-gray"
                                                onClick={e => this.clearSearch()}
                                            >
                                                Clear
                                            </button>
                                        </div>
                                    }
                                </div>
                                    </div>
                                }
                           
                            <div className="row m-0">
                                <div className="table-responsive sticky-table-wrapper mt-3">
                                    {this.record(currentRecords)}
                                </div>
                                <div className="row">
                                    <div className="col-md-9 pl-0">
                                        <div className="mt-2 float">
                                            {
                                                GSTList.length > 0 ?
                                                    <Pagination
                                                        nPages={nPages}
                                                        currentPage={currentPage}
                                                        setCurrentPage={this.updateItem}
                                                    /> : <></>
                                            }

                                        </div>
                                    </div>
                                    <div className="col-md-3 text-right">
                                        <div className="tab-rec mt-3" style={{ float: "right" }}>
                                            <p>{`${currentPage} of ${nPages} pages`}</p>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>
                </>
                <Modal isOpen={isOpen} onRequestClose={() => this.setState({ isOpen: false })}>
                    <div className="modal-dialog" style={{ marginTop: '20%' }}>
                        <div className="modal-content confirm-logout">
                            <div class="modal-header text-right p-2">
                                <h5 class="modal-title">Do you really want to delete this record?</h5>

                                {/* <button type="button " class="close pop-close" data-dismiss="modal"
                                    onClick={() => this.setState({ isOpen: false })}
                                ><span aria-hidden="true" class="pop-cancel">&times;</span></button> */}
                            </div>
                            {/* <div class="modal-body">
                                <div class="row">
                                </div>
                            </div> */}
                            <div class="modal-footer p-1">
                                <div class="form-group text-right mod-fot">
                                    <button type="button" class="btn btn-aqua"
                                        onClick={(e) => this.deleteGSTMaster(this.state.deleteID)}
                                    >Yes</button>
                                    <button type="button" class="btn btn-gray" data-dismiss="modal" style={{ marginLeft: '5px' }}
                                        onClick={() => this.setState({ isOpen: false })}
                                    >No</button>
                                </div>
                            </div>

                        </div>
                    </div>
                </Modal>
                <Footer />
            </>)
    }

}
export default withRouter(connect(null, { fill_action, deleteGSTMaster_action, getgstMasterList_action })(GSTList));